import React from 'react';
import ExchangeForm from './ExchangeForm';
import CoinPriceTable from './CoinPriceTable';
import '../style/ExchangePage.css';

export default function ExchangePage() {
  return (
    <section className="exchange-section-wrapper">
      <div className="exchange-container">
        {/* Левый блок: Форма */}
        <div className="exchange-card form-card-shadow">
          <ExchangeForm />
        </div>

        {/* Правый блок: Таблица */}
        <div className="exchange-card table-card-shadow">
          <CoinPriceTable />
        </div>
      </div>
    </section>
  );
}